module.exports = {};



// WEBPACK FOOTER //
// ./~/core-js/modules/_iterators.js